export default __webpack_public_path__ + "static/media/logo.d09941e4.png";